module.exports = __webpack_public_path__ + "img/audio.843a69aa.svg";